<template lang="pug">
pr-wrapper.d-flex.align-items-end(fs)
  .prayer.w-100.h-100(v-nv:scope="'prayer'", @nv-back="close")
    .leftside.p-5(v-nv.current)
      .header-wrapper
        pr-text(size="xlarge", weight="bold") {{ $t("Prayer Times") }}
        pr-text(size="medium")
          moment.small(format="dddd, DD MMMM", date, live) 
    pr-wrapper.rightside.border-left
      .prayers
        .period.background.border-bottom(v-for="period in periods", :class="{ activeElement: period.active }")
          pr-text.period-name(:size="period.active ? 'large' : 'medium'") {{ $t(period.name) }}
          .period-icon.d-flex.flex-column.align-items-center
            i(:class="[period.icon, period.active ? 'fa-5x' : 'fa-2x text-muted']")
            .countdown.border-top.mt-2.pt-2(v-if="period.active") {{ period.date | moment("from", "now") }}
          .period-clock
            pr-text(:size="period.active ? 'large' : 'medium'", weight="bold") {{ period.date.format("HH:mm") }}
          imagec(v-if="period.active", covered, vertical, :src="`v2/assets/images/prayer/${period.key}.png`")
</template>

<script>
import { mapGetters } from "vuex"
export default {
  name: "prayer",
  data() {
    return {
      countdown_: null
    }
  },
  computed: {
    periods() {
      if (!this.prayer) return []
      const { fajr, dhuhr, asr, maghrib, isha } = this.prayer
      const now_ = new Date()

      const periods_ = [
        { name: "Fajr", key: "fajr", date: this.$moment(fajr), active: false, icon: "fal fa-sunrise" },
        { name: "Dhuhr", key: "dhuhr", date: this.$moment(dhuhr), active: false, icon: "fal fa-sun" },
        { name: "Asr", key: "asr", date: this.$moment(asr), active: false, icon: "fal fa-sun-cloud" },
        { name: "Maghrib", key: "maghrib", date: this.$moment(maghrib), active: false, icon: "fal fa-sunset" },
        { name: "Isha", key: "isha", date: this.$moment(isha), active: false, icon: "fal fa-moon-stars" }
      ]
      const active_ = periods_.find(item => item.date.valueOf() > now_.valueOf())
      if (active_) active_.active = true

      return periods_
    },
    ...mapGetters("rss", ["prayer"])
  },
  async activated() {
    await this.$store.dispatch("rss/fetchPrayer")
    if (!this.prayer) return this.close()
    _$.nav.sync("prayer", true)
    __.platform.background("bg.png".host("v2/assets/images/prayer/"), "prayer.mp4".host("v2/assets/images/prayer/"))
  },
  methods: {
    close() {
      __.platform.go()
    }
  }
}
</script>

<style lang="scss" scoped>
.prayer {
  display: flex;

  .leftside {
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    flex-grow: 1;
  }

  .rightside {
    display: flex;
    overflow: unset;
    width: 40%;
    box-shadow: -5px 0 15px 2px rgba(0, 0, 0, 0.25);

    .prayers {
      display: flex;
      flex-direction: column;
      flex: 1 0 auto;

      .period {
        display: flex;
        align-items: center;
        overflow: hidden;
        position: relative;
        padding: 30px 0;

        &.no-active {
          flex: 1 0 auto;
        }

        &:last-child {
          border-bottom: 0 !important;
        }

        .period-name {
          width: 30%;
          padding-left: 50px;
        }
        .period-icon {
          display: flex;
          justify-content: center;
          flex-grow: 1;
        }
        .period-clock {
          padding-right: 50px;
          display: flex;
          flex: 0 1 auto;
        }
        &.activeElement {
          background: #000;
        }

        &.nv-el-current,
        &.activeElement {
          z-index: 1;
          flex: 1 0 auto;
          position: relative;

          .imagec {
            display: block;
            z-index: -1;
          }
        }

        .imagec {
          position: absolute !important;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          display: none;
          opacity: 0.5;
        }
      }
    }
  }
}
</style>
